import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";

@Component({
	selector: "app-pos-item-modifier",
	templateUrl: "./pos-item-modifier.component.html",
	styleUrls: ["./../../../../pos.scss"],
})
export class PosItemModifierComponent implements OnInit {
	@Input() itemSelected: OOCanvasMenuItem;
	@Output() itemSelectedChange = new EventEmitter<OOCanvasMenuItem>();

	constructor() {}

	ngOnInit(): void {}

	onClose() {
		this.itemSelectedChange.emit(undefined);
	}
}
